import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isDefaultOpen?: boolean;
}
export const FAQItem = ({
  question,
  answer,
  isDefaultOpen = false
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen);
  return <div className="border-b border-gray-200 py-4" data-id="element-53">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full text-left focus:outline-none" data-id="element-54">
        <h3 className="text-lg font-medium text-dark" data-id="element-55">{question}</h3>
        <span className="text-primary ml-2" data-id="element-56">
          {isOpen ? <ChevronUp size={20} data-id="element-57" /> : <ChevronDown size={20} data-id="element-58" />}
        </span>
      </button>
      {isOpen && <div className="mt-3 text-gray-600" data-id="element-59">
          <p data-id="element-60">{answer}</p>
        </div>}
    </div>;
};